import { useEffect, useState } from "react";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/24/solid";
import PlatformData from "../../../Json/devicetype.json";

const PlatformSelect = ({ selectedPlatform, setSelectedPlatform }) => {
  const [platformlist, setPlatformList] = useState(PlatformData);

  useEffect(() => {
    setPlatformList(PlatformData);
    if (!selectedPlatform && PlatformData[0]) {
      setSelectedPlatform(PlatformData[0]);
    }
  }, [selectedPlatform, setSelectedPlatform]);

  return (
    <Listbox value={selectedPlatform} onChange={setSelectedPlatform}>
      <div className="relative">
        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm">
          <span className="block truncate text-gray-600">{selectedPlatform?.name || "Select Platform"}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="size-5 text-gray-400" />
          </span>
        </ListboxButton>

        <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
          {platformlist.map((list) => (
            <ListboxOption
              key={list.id}
              value={list}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{list.name}</span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="size-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};

export default PlatformSelect;
